export enum RecentInteractionsFilter {
  inbox = 'active',
  unread = 'unread',
  blocked = 'blocked',
  archived = 'archived',
}
